// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__VHqdu","buttons":"SendReceipts_buttons__1wCFI","email":"SendReceipts_email__2X4-W","bookApptTitle":"SendReceipts_bookApptTitle__1SIXo"};